// realtime/LayoutChart/LayoutGrid.jsx
import { Box } from '@mui/material';

export default function LayoutGrid({ columns = 1, gap = 1, children }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gridAutoRows: '1fr',
        gap: (theme) => theme.spacing(gap),
        width: '100%',
        height: '100%',
      }}
    >
      {children}
    </Box>
  );
}
